import { FileText, FileSpreadsheet, Mail, Globe } from "lucide-react";
import { exportToPDF, exportToExcel, openInHTML, openInOutlook } from "../lib/exporters";

/**
 * ExportBar — renders 4 buttons that invoke filter-aware exports.
 *
 * Props:
 *   spec      : () => ({ title, subtitle, filters, columns, rows, filename, ... })
 *               (function, so filters/rows are read lazily on click)
 *   align     : "right" | "left"  (layout hint)
 *   size      : "sm"  | "md"
 */
export default function ExportBar({ spec, align = "right", size = "sm", className = "" }) {
  const pad = size === "sm" ? "px-2.5 py-1.5 text-xs" : "px-3 py-2 text-sm";
  const iconSize = size === "sm" ? 12 : 14;

  const handler = (fn, extras) => () => {
    try {
      const s = spec();
      if (!s || !s.rows) return;
      fn(s, extras);
    } catch (e) {
      console.error("Export failed:", e);
      alert("Export failed — see console for details.");
    }
  };

  const base = `${pad} rounded-md border border-slate-300 text-slate-700 bg-white hover:bg-slate-50 inline-flex items-center gap-1.5 font-medium transition`;

  return (
    <div data-testid="export-bar"
         className={`flex flex-wrap gap-1.5 ${align === "right" ? "justify-end" : ""} ${className}`}>
      <button onClick={handler((s) => exportToPDF(s))} className={base} data-testid="export-pdf">
        <FileText size={iconSize} /> PDF
      </button>
      <button onClick={handler((s) => exportToExcel(s))} className={base} data-testid="export-excel">
        <FileSpreadsheet size={iconSize} /> Excel
      </button>
      <button onClick={handler((s) => openInOutlook(s))} className={base} data-testid="export-outlook">
        <Mail size={iconSize} /> Outlook
      </button>
      <button onClick={handler((s) => openInHTML(s))} className={base} data-testid="export-html">
        <Globe size={iconSize} /> HTML
      </button>
    </div>
  );
}
